import React, { Fragment, useEffect, useState } from 'react';
import T from 'prop-types';
import { isEmpty, keys, sortBy } from 'lodash-es';

import Tooltip from '../../../../components/Tooltip';
import SwitchStores from '../../../../components/SwitchStores';

import { isUnified } from '../../../../utils/helpers';

const defaultRenderStoreLine = (node) => node;

const isOverall = ({ category_id }) => [98, 36].includes(category_id);

const WidgetRanks = ({
  widgetData,
  type = 'ranks',
  country_iso = ['WW'],
  appStore,
  size,
  renderStoreLine = defaultRenderStoreLine,
}) => {
  const store = isUnified(appStore) ? 'itunes_connect' : appStore;
  const [activeStore, setActiveStore] = useState(store);

  const isSingleCountry =
    country_iso.length === 1 && !REGIONS_CODES_WITH_WW.includes(country_iso[0]);

  const sortedRanksData = keys(widgetData[type]).reduce((result, catStore) => {
    const catByStore = widgetData[type][catStore];
    return { ...result, [catStore]: sortBy(catByStore, ['order_index']) };
  }, {});

  const catByStore = sortedRanksData[activeStore];
  const hasOverall = catByStore?.some(isOverall);
  const overallLabel = isSingleCountry ? 'Overall Rank' : 'Overall';

  const catByStoreNormalized = () => {
    if (!catByStore) return [];

    return hasOverall
      ? catByStore
      : [
          {
            category_id: activeStore === 'itunes_connect' ? 36 : 98,
            countries: catByStore[0].countries,
            rank: '-',
            countries_present: 0,
          },
          ...catByStore,
        ];
  };

  // Effects
  useEffect(() => setActiveStore(store), [store]);

  return (
    <div className="widget-body rank-widget">
      <div className="widget-body__table-body">
        {isEmpty(catByStore) ? null : (
          <div key={`${activeStore}-store-rank`} className="store-rank single-store">
            <div className="rank-table-header">
              <p>Category</p>
              <p>{isSingleCountry ? 'Rank' : 'Countries'}</p>
            </div>
            {catByStoreNormalized().map((catStore) => {
              const { category_id, countries, countries_present, rank } = catStore;
              const isUnranked = countries === 0 || rank === 0;
              return (
                <div key={category_id} className="widget-body__table-body-item">
                  <div className="widget-body__table-body-item-name d-flex">
                    <Tooltip
                      id="category_id"
                      content={<span>{CATEGORIES[activeStore][category_id]}</span>}
                    >
                      <span className="text-truncate">
                        {isOverall({ category_id })
                          ? overallLabel
                          : CATEGORIES[activeStore][category_id]}
                      </span>
                    </Tooltip>
                  </div>
                  <div className="widget-body__table-body-item-numb">
                    {isSingleCountry ? (
                      <Fragment>
                        {isUnranked && 'Unranked'}
                        {!isUnranked && rank === '-' && rank}
                        {!isUnranked && rank !== '-' && `#${rank}`}
                      </Fragment>
                    ) : (
                      <span className="widget-body__table-body-item-numb-percent">
                        {isUnranked ? 'Unranked' : `${countries_present}/${countries}`}
                      </span>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
      {renderStoreLine(
        isUnified(appStore) && (
          <div className="rank-switch-store">
            <SwitchStores
              active={activeStore}
              size={size}
              onChange={(value) => setActiveStore(value)}
            />
          </div>
        )
      )}
    </div>
  );
};

WidgetRanks.propTypes = {
  widgetData: T.object.isRequired,
  type: T.string,
  country_iso: T.array,
  appStore: T.string,
  size: T.string,
  renderStoreLine: T.func,
};

export default WidgetRanks;
